// extracted by mini-css-extract-plugin
export var backdropBlur = "_km-0";
export var contentCard = "_km-5";
export var frame = "_km-2";
export var image = "_km-4";
export var imagePane = "_km-3";
export var modal = "_km-1";